import { render, staticRenderFns } from "./KakaoTemplatePrecaution.vue?vue&type=template&id=6acd6140&scoped=true&"
import script from "./KakaoTemplatePrecaution.vue?vue&type=script&lang=ts&"
export * from "./KakaoTemplatePrecaution.vue?vue&type=script&lang=ts&"
import style0 from "./KakaoTemplatePrecaution.vue?vue&type=style&index=0&id=6acd6140&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6acd6140",
  null
  
)

export default component.exports